import { render } from "./ForumEditProfile.vue?vue&type=template&id=540b2c93"
import script from "./ForumEditProfile.vue?vue&type=script&lang=js"
export * from "./ForumEditProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__